import React from "react";
import './Image.scss'
import Swiper from 'components/misc/Swiper';
function Image({bloc}) {
  return <Swiper images={bloc.images} size={bloc.size} align='left'/>;
}
export default Image;
